// extracted by mini-css-extract-plugin
module.exports = {"message":"FormattedMessage_message__xNq9x"};